/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Badge, BadgeProps } from "@mui/material";

export default function StyledBadge(props: BadgeProps) {
    return (
        <Badge
            sx={{
                "& .MuiBadge-badge": {
                    top: -4,
                    border: theme => `2px solid ${theme.palette.background.paper}`
                },
                ...(props.sx ? props.sx : {}),
            }}
            color={"info"}
            {...props}
        />
    );
}